import { routers } from "@/helper/routers";

export default [
  {
    path: routers.RETRY_LEAD,
    name: "retry-lead",
    component: () => import("@/views/retry-lead/Index.vue"),
  },
];
